import BookIcon from '@material-ui/icons/Book'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { Datagrid, DateField, EditButton, List, TextField, Filter, TextInput } from 'react-admin'
import { ListActionToolbar, ListStyles } from '../utilities/ListComponents'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@material-ui/core/InputAdornment'
export const UserIcon = BookIcon

const UserFilter = props => (
  <Filter { ...props }>
    <TextInput label='Search by Name' source='name' alwaysOn  
      InputProps={ { endAdornment: (<InputAdornment position='end'><SearchIcon color='disabled' /></InputAdornment>) } }
    />


  </Filter>
)


const UserList = withStyles(ListStyles)(({ classes, ...props }) => (
  <List { ...props } filters={ <UserFilter /> } sort={ { field: 'id', order: 'DESC' } }  >
    <Datagrid>

      <TextField label='First Name' source='name' />
      <TextField label='Last Name' source='last_name' />
      <TextField label='Email' source='email' />
      <TextField label='Phone' source='phone' />
      <TextField label='User Name' source='Authentication.username' sortable={ false } />
      <DateField locales="en-CA" label='Updated Time' source='date_last_updated' sortable={ false } />

      <ListActionToolbar>
        <EditButton />
      </ListActionToolbar>

    </Datagrid>
  </List>
))

export default UserList
